<template>
    <div class="page" v-loading="loading">
        <el-breadcrumb>
            <el-breadcrumb-item>财务管理</el-breadcrumb-item>
            <el-breadcrumb-item>康家钱包</el-breadcrumb-item>
        </el-breadcrumb>

        <el-form :inline="true" class="top">
            <el-form-item>
                <el-input v-model="filter.order_no" placeholder="搜索订单号" size="mini" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-date-picker v-model="date" type="daterange" range-separator="——" start-placeholder="开始日期"
                    end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" size="mini" style="width: 260px;"
                    @change="change">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-select v-model="filter.action" placeholder="请选择交易类型" value-key="label" size="mini" clearable
                    style="width: 170px;">
                    <el-option label="充值" :value="1"></el-option>
                    <el-option label="卖货增收" :value="2"></el-option>
                    <el-option label="上货 / 支付刊登费" :value="3"></el-option>
                    <el-option label="退款（订单补贴）" :value="4"></el-option>
                    <el-option label="发起提现" :value="5"></el-option>
                    <el-option label="提现成功" :value="6"></el-option>
                    <el-option label="提现失败" :value="7"></el-option>
                    <el-option label="违规处罚--发货违规" :value="8"></el-option>
                    <el-option label="佣金返现" :value="9"></el-option>
                    <el-option label="订单返现" :value="10"></el-option>
                    <el-option label="预估入账余额" :value="11"></el-option>
                    <el-option label="预估出账余额" :value="12"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="filter.type" placeholder="请选择收支类型" value-key="label" size="mini" clearable
                    style="width: 170px;">
                    <el-option label="收入" :value="1"></el-option>
                    <el-option label="支出" :value="2"></el-option>
                    <el-option label="提现" :value="3"></el-option>
                    <el-option label="预估佣金收入" :value="4"></el-option>
                    <el-option label="预估佣金支出" :value="5"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="toSearch">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="success" size="mini" @click="refresh">刷新</el-button>
            </el-form-item>
        </el-form>

        <el-form :inline="true">
            <el-form-item>
                <div class="wallet-index">
                    <p>总余额</p>
                    <p>{{ estimate }}</p>
                </div>
            </el-form-item>
            <el-form-item>
                <div class="wallet-index">
                    <p>冻结余额</p>
                    <p>{{ balance }}</p>
                </div>
            </el-form-item>
            <el-form-item>
                <div class="wallet-index">
                    <p>可用余额（元）</p>
                    <p>{{ balance_available }}</p>
                </div>
            </el-form-item>
        </el-form>

        <el-table :data="tableData" :header-cell-style="{background:'#F5F5F5'}" size="mini"
            style="width: 100%; margin-bottom: 20px;" stripe border :cell-style="changeCellStyle">
            <el-table-column type="index" label="序号" width="80"></el-table-column>
            <el-table-column prop="info" label="订单信息">
                <template slot-scope="scope">
                    <div v-if="scope.row.info">
                        <p class="orderinfo">订单号：{{ scope.row.info.order_no ? scope.row.info.order_no : '空' }}</p>
                        <p class="orderinfo">订单金额：{{ scope.row.info.total ? scope.row.info.total : '空' }}</p>
                        <p class="orderinfo">下单时间：{{ scope.row.info.created_at ? scope.row.info.created_at : '空' }}</p>
                        <p class="orderinfo">商品来源：{{ scope.row.info.store ? scope.row.info.store : '空' }}</p>
                    </div>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="info" label="预估佣金">
				<template slot-scope="scope">
					{{ scope.row.info && scope.row.info.commission }}
				</template>
			</el-table-column> -->
            <el-table-column prop="balance_available" label="可提佣金">
                <template slot-scope="scope">
                    {{ scope.row.balance_available ? scope.row.balance_available : '' }}
                </template>
            </el-table-column>
            <el-table-column prop="action" label="交易类型">
                <template slot-scope="scope">
                    {{ scope.row.action == 1 ? '充值' : scope.row.action == 2 ? '卖货增收' : scope.row.action == 3 ?
                    '上货,支付刊登费' : scope.row.action == 4 ? '退款（订单补贴）' :
                    scope.row.action == 5 ? '发起提现': scope.row.action == 6 ? '提现成功': scope.row.action == 7 ? '提现失败' :
                    scope.row.action == 8 ? '违规处罚' :
                    scope.row.action == 9 ? '佣金返现':scope.row.action == 10 ? '订单返现': scope.row.action == 11 ?
                    '预估入账余额':scope.row.action == 12 ? '预估出账余额': '' }}
                </template>
            </el-table-column>
            <el-table-column prop="type" label="收支类型">
                <template slot-scope="scope">
                    <p
                        :class="scope.row.type == 1 ? 'success' : scope.row.type == 2 ? 'error' : scope.row.type == 3 ? 'info' : ''">
                        {{ scope.row.type == 1 ? '+收入' : scope.row.type == 2 ? '-支出' : scope.row.type == 3 ? '提现' :
                        scope.row.type == 4 ?'预估佣金收入' : scope.row.type == 5 ? '预估佣金支出' : ' '}}
                    </p>
                </template>
            </el-table-column>
            <el-table-column prop="balance" label="当前总余额">
                <template slot-scope="scope">
                    {{ scope.row.balance }}
                </template>
            </el-table-column>
            <el-table-column prop="balance_available" label="当前可用余额">
                <template slot-scope="scope">
                    {{ scope.row.balance_available }}
                </template>
            </el-table-column>
            <el-table-column prop="balance_unavailable" label="当前审核中佣金">
                <template slot-scope="scope">
                    {{ scope.row.balance_unavailable }}
                </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注">
                <template slot-scope="scope">
                    {{ scope.row.remark }}
                </template>
            </el-table-column>
        </el-table>

        <el-pagination background layout="prev,pager,next,total" :page-count="maxpage" :total="total" :page-size="20"
            @current-change="pageChange"></el-pagination>

    </div>
</template>

<script>
    export default {
        name: 'Wallet',
        data() {
            return {
                loading: false,
                date: '',
                filter: {
                    page: '',
                    order_no: '',
                    start_time: '',
                    end_time: '',
                    action: '',
                    type: '',
                },
                tableData: [],
                page: 1,
                maxpage: 1,
                total: 0,
                balance: '',
                balance_available: '',
                balance_unavailable: '',
                estimate: '',
            }
        },
        methods: {
            getData() {
                // this.loading = true
                // this.$util.get('agent/wallet_record')
                // 	.then(res => {
                // 		console.log(res)
                // 		this.loading = false
                // 		this.balance = res.balance ? res.balance : '0.00'
                // 		this.balance_available = res.balance_available ? res.balance_available : '0.00'
                // 		this.balance_unavailable = res.balance_unavailable ? res.balance_unavailable : '0.00'
                // 		this.estimate = res.estimate ? res.estimate : '0.00'
                // 	})
                // this.getTransTransaction()
            },
            getTransTransaction() {
                this.filter = {
                    page: this.page,
                    action: this.filter.action,
                    order_no: this.filter.order_no,
                    start_time: this.filter.start_time,
                    end_time: this.filter.end_time,
                    type: this.filter.type,
                }
                // this.$util.get('agent/getTransTransaction', this.filter)
                // 	.then(res => {
                // 		console.log(res.data)
                // 		this.tableData = res.data
                // 		this.total = res.total
                // 		this.maxpage = res.last_page
                // 	})
            },
            pageChange(page) {
                this.tableData = []
                this.page = page
                this.getData()
            },
            toSearch() {
                this.page = 1
                this.maxpage = 1
                this.total = 0
                this.tableData = []
                this.getData()
            },
            refresh() {
                this.getData()
            },
            change(value) {
                if (value) {
                    this.filter.start_time = value[0]
                    this.filter.end_time = value[1]
                } else {
                    this.filter.start_time = ''
                    this.filter.end_time = ''
                }
            },
            changeCellStyle(row) {
                if (row.column.label == '订单信息') {
                    return "text-align: left;"
                } else {
                    return "text-align: center;"
                }
            },
        },
        activated() {
            this.getData()
        }
    }
</script>

<style scoped>
    .el-table {
        margin-top: 30px;
    }

    .el-table /deep/ .has-gutter .cell {
        text-align: center;
    }

    .el-date-editor--daterange.el-input__inner {
        width: 265px;
    }

    .el-form-item {
        margin-bottom: 0px;
    }

    .top {
        margin-top: 30px;
    }

    .wallet-index,
    .withdrawal {
        width: 285px;
        border-right: 1px solid #888888;
        text-align: center;
    }

    .wallet-index p:first-child {
        font-size: 22px;
        font-weight: 500;
        font-family: PingFang SC;
        line-height: 20px;
        color: #111111;
        margin: 20px 0px 0px;
    }

    .wallet-index p:last-child {
        font-size: 26px;
        font-weight: bold;
        font-family: PingFang SC;
        line-height: 30px;
        color: #F10019;
        margin: 10px 0px 0px;
    }

    .withdrawal {
        border: none;
        line-height: 80px;
    }

    .wrap /deep/ .el-form-item__content {
        margin-bottom: 20px;
    }

    .info,
    .success,
    .error {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 20px;
        color: #888888;
    }

    .success {
        color: #0CC428;
    }

    .error {
        color: #F10019;
    }
</style>